module.exports = __webpack_public_path__ + "img/harsh-cornering.f54f8417.svg";